import { Formik } from 'formik';
import { isEmpty } from 'lodash';
import React from 'react';
import Form, { FormElement, Label } from '@dashboard/components/Form';
import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { TextInput } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useUserQueries from '@dashboard/hooks/queries/useUserQueries';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import { useToast } from '@dashboard/context/ToastContext';

const NameForm = () => {
  const { user, setUser } = useAuth();
  const { emitToast } = useToast();
  const { updateUser } = useUserQueries();

  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: user.name,
      }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updateUser(values, user._id);

        if (data) {
          actions.setStatus('');
          actions.resetForm({
            values: {
              name: data.name,
            },
          });

          setUser(data);

          emitToast({
            title: 'Profile updated',
            description: 'Your name has been updated successfully.',
            type: 'success',
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ status, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <FormElement>
            <Label htmlFor="name">First name</Label>
            <TextInput type="text" id="name" name="name" placeholder="First name" required />
          </FormElement>

          <FormElement>{status && status}</FormElement>

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </Form>
      )}
    </Formik>
  );
};

export default NameForm;
